import { useState } from 'react';
import { OperatorConfigTab } from '../organisms/OperatorConfigTab';
import { ExcludedMachinesTab } from '../organisms/ExcludedMachinesTab';
import { ReimbursementFeesTab } from '../organisms/ReimbursementFeesTab';

type BillingTab = 'operator-config' | 'excluded-machines' | 'reimbursement-fees';

export function BillingConfigPage() {
  const [activeTab, setActiveTab] = useState<BillingTab>('operator-config');

  const tabs: { id: BillingTab; label: string }[] = [
    { id: 'operator-config', label: 'Operator Config' },
    { id: 'excluded-machines', label: 'Excluded Machines' },
    { id: 'reimbursement-fees', label: 'Reimbursement Fees' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page header */}
      <div className="px-6 py-4 bg-white border-b border-gray-200">
        <div className="border-l-4 border-yellow-400 pl-4">
          <h1 className="text-lg font-semibold text-gray-900">Billing Configuration</h1>
        </div>
      </div>

      {/* Tab navigation */}
      <div className="bg-white border-b border-gray-200 px-6">
        <div className="flex gap-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-4 px-2 border-b-4 font-medium text-sm transition-all ${
                activeTab === tab.id
                  ? 'border-yellow-400 text-gray-900 font-semibold'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab content */}
      <div className="p-6">
        {activeTab === 'operator-config' && <OperatorConfigTab />}
        {activeTab === 'excluded-machines' && <ExcludedMachinesTab />}
        {activeTab === 'reimbursement-fees' && <ReimbursementFeesTab />}
      </div>
    </div>
  );
}
